// src/layouts/SiteLayout.tsx
import * as React from 'react';
import { Box, Divider, Paper, Typography, useMediaQuery, useTheme } from '@mui/material';

import { A11ySkipLink } from './A11ySkipLink';
import { A11yToolbar } from './A11yToolbar';
import { HeaderSiteRedeSocial } from '../../menuSite/HeaderSiteRedeSocial';
import { HeaderSiteLogo } from './HeaderSiteLogo';
import { HeaderSiteMenu } from '../../menuSite/HeaderSiteMenu';
import { PainelAtalhosSite } from './PainelAtalhosSite';
import configSiteUrls from '../../../configs/configSiteUrls';
import { SiteRodape } from './SiteRodape';

export function SiteLayout({ children }: { children: React.ReactNode }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const headerMenu = theme.custom?.headerSiteMenu || {};
  const backgroundColorMobile = headerMenu.backgroundColorMobile || '#000000';
  

  const atalhos = [
    { imagem: '/images/ouvidoria/BannerOuvidoria.png', alt: 'Ouvidoria', link: configSiteUrls.SITE_OUVIDORIA_PUBLIC_MENU },
    { imagem: '/images/ouvidoria/BannerCentroApoio.jpeg', alt: 'Centro de Apoio', link: configSiteUrls.SITE_CENTRO_APOIO_PUBLIC_MENU },
    { imagem: '/images/ouvidoria/BannerAcessoInformacao.png', alt: 'Acesso a informação', link: configSiteUrls.SITE_ACESSO_INFORMACAO_PUBLIC_MENU }
  ];

  return (
    <Box
      id="container-main"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minHeight: '100vh',
        width: '100%',
        padding: 0,
        backgroundColor: theme.palette.background.default,
        fontFamily: theme.typography.fontFamily
      }}
    >
      {/*Esse componente A11ySkipLink é um link de acessibilidade (skip link), uma prática importante para tornar seu site mais acessível a pessoas que usam leitores de tela ou navegam por teclado. */}
      <A11ySkipLink />
      {/*Esse componente A11yToolbar é uma barra de ferramentas de acessibilidade que oferece várias funcionalidades para melhorar a experiência do usuário, especialmente para aqueles com necessidades especiais. */}
      <A11yToolbar />

      <Box
        id="container-header"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: {
            xs: '100%', // celulares
            sm: '95%', // celulares grandes / tablets pequenos
            md: '90%', // tablets / notebooks pequenos
            lg: '85%', // notebooks médios
            xl: '80%' // monitores maiores
          },
          padding: 0,
          mb: 0
        }}
      >
        {!isMobile && (
          <Box id="header-rede-social" sx={{ width: '100%' }}>
            <HeaderSiteRedeSocial />
          </Box>
        )}

        <Box id="header-site-logo">
          <HeaderSiteLogo />
        </Box>
      </Box>

      <Box
        id="header-site-menu"
        sx={{
          width: '100%',
          p: 0,
          m: 0,
          backgroundColor: backgroundColorMobile || 'transparent'
        }}
      >
        <Box
          id="header-site-menu"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: {
              xs: '100%', // celulares
              sm: '95%', // celulares grandes / tablets pequenos
              md: '90%', // tablets / notebooks pequenos
              lg: '85%', // notebooks médios
              xl: '80%' // monitores maiores
            },
            padding: 0,
            mb: 0,
            mx: 'auto'
          }}
        >
          <HeaderSiteMenu />
        </Box>
      </Box>

      <Box sx={{ width: '100%' }}>
        <Divider
          orientation="horizontal"
          sx={{
            borderColor: theme.palette.divider || '#EBEBEB',
            borderBottomWidth: 1,
            mb: 1
          }}
        />
      </Box>

      <Box
        id="container-content"
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' }, // coluna em mobile, linha em desktop
          width: {
            xs: '100%',
            sm: '95%',
            md: '90%',
            lg: '85%',
            xl: '80%'
          },
          minHeight: '100vh',
          padding: 0,
          gap: 2
        }}
      >
        {/* Conteúdo principal */}
        <Paper
          sx={{
            flex: 1, // ocupa todo o espaço disponível
            p: 2,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'top',
            backgroundColor: theme.palette.background.paper
          }}
        >
          {children}
        </Paper>

        {/* Atalhos */}
        <Box
          sx={{
            width: { xs: '100%', md: 250 }, // largura fixa desktop, full width mobile
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            alignItems: { xs: 'center', md: 'flex-end' }, // alinha à direita no desktop
            mt: { xs: 2, md: 0 } // margem topo só no mobile
          }}
        >
          <PainelAtalhosSite atalhos={atalhos} />
        </Box>
      </Box>

      <SiteRodape />
    </Box>
  );
}
